import { render, staticRenderFns } from "./Pinia.vue?vue&type=template&id=296eaeba&scoped=true&"
import script from "./Pinia.vue?vue&type=script&lang=js&"
export * from "./Pinia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "296eaeba",
  null
  
)

export default component.exports